module.exports = __webpack_public_path__ + "fonts/Inter-500-vietnamese54.9df1755.woff2";